import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router-dom';
import './sign-up.scss';
import { ROUTES } from '..';
import { Box, CircularProgress, Container, Paper, Typography, Dialog } from '@material-ui/core';
import { isNode } from "browser-or-node";
import ChangePasswordForm from './ChangePasswordForm';
import { Alert } from '@material-ui/lab';
import ChangePasswordSuccess from './ChangePasswordSuccess';
import { useMediaQuery } from 'react-responsive';


const BASE_URL = isNode
  ? process.env.NEXT_PUBLIC_LOCAL_BASE_URL
  : process.env.NEXT_PUBLIC_BASE_URL;

function ResponsiveModal({ children, ...props }) {
  const isMobile = useMediaQuery({ maxWidth: 670 })
  return <Dialog maxWidth="xs" fullScreen={isMobile} {...props}>
    {children}
  </Dialog>
}

export default function ForgotPassword() {
  const [isValidToken, setIsValidToken] = useState(false)
  const [checkingToken, setCheckingToken] = useState(true);
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const { token } = useParams();

  const history = useHistory();

  useEffect(() => {
    fetch(`${BASE_URL}/forgot-password/${token}`)
    .then((res) => res.json())
    .then((data) => {
      setCheckingToken(false);
      if (data.code === 'token_valid') {
        setIsValidToken(true);
      } else {
        setIsValidToken(false);
        setErrorMsg('Ce lien est invalide !')
      }
    })
    .catch((error) => {
      setCheckingToken(false);
      setIsValidToken(false);
      setErrorMsg('Ce lien est invalide !')
    }) 
  }, []);

  const Wrap = ResponsiveModal;
  return (
    <Box pt={16} className="main-container">
      {/* <Img
        className='background'
        src={"https://www.clevermate.fr/img/signup-page-background.jpg?v=ef8e8b"}
        alt={'signup-background'}
      /> */}
      <Container style={{ padding: '190px 0 64px 0'}}>
        <Wrap open={true}>
          <Box style={{ padding: 24, margin: '0 auto', position: 'relative' }}>
            <a href="/">
              <div className='signup-logo'>
                <img src="/img/clevermate-signature.png" alt="clevermate signature" />
              </div>
            </a>
            <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
              Réinitialisation du mot de passe
            </Typography>
            {!passwordChanged && checkingToken &&
              <Box height={162} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <CircularProgress
                  variant="indeterminate"
                  disableShrink
                  size={40}
                  thickness={4}
                />
              </Box>
            }
            {errorMsg &&
              <Alert severity="error">{errorMsg}</Alert>}
            {passwordChanged &&
              <ChangePasswordSuccess />}
            {!passwordChanged && !checkingToken && isValidToken &&
              <ChangePasswordForm
                onSubmit={(values) => {
                  setErrorMsg(null);
                  return fetch(`${BASE_URL}/forgot-password/${token}`, {
                    method: 'PUT',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(values)
                  })
                }}
                onSuccess={(data) => {
                  if (data.code === 'password_changed') {
                    setPasswordChanged(true);
                    setTimeout(() => {
                      history.push("/sign-up");
                    }, 2000);
                  } else {
                    setErrorMsg('Une erreur est survenue lors du traitement de votre requête !')
                  }
                }}
                onFailure={() => {
                  setErrorMsg('Une erreur est survenue lors du traitement de votre requête !')
                }}
              />
            }
          </Box>
        </Wrap>
      </Container>
    </Box>
  );
}